import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWheelPaddle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M66.652 2.5c-10.768 0-20.024 3.187-26.746 9.912C30.462 21.861 26 36.64 26 49.999s4.463 28.139 13.906 37.588c6.721 6.725 17.202 9.913 26.746 9.913 2.729 0 7.273-2.557 7.239-6.29-.031-3.333-2.845-7.1-4.48-10.554-1.288-2.722-3.822-5.014-4.194-8.002-.278-2.231-.072-5.024 1.57-6.56 6.323-5.913 6.325-4.45 25.604-4.343 4.314.024 6.253-.248 6.392-4.214l-.064-14.09c-.009-4.176-2.103-4.409-6.328-4.409-19.638 0-19.663 1.79-25.775-4.425-1.91-1.944-1.733-5.399-1.246-8.08.49-2.705 2.817-4.728 4.04-7.19 1.718-3.455 4.641-6.918 4.623-10.613-.017-3.314-4.408-6.231-7.381-6.231z" })
});
export default SvgWheelPaddle;
